import { render } from "./DetalharCategoriaProduto.vue?vue&type=template&id=ff3f67e8&scoped=true"
import script from "./DetalharCategoriaProduto.vue?vue&type=script&lang=js"
export * from "./DetalharCategoriaProduto.vue?vue&type=script&lang=js"

import "./DetalharCategoriaProduto.vue?vue&type=style&index=0&id=ff3f67e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff3f67e8"]])

export default __exports__